<template>
  <md-card class="md-card-stats" style="min-width: 100px">
    <div
      style="
        display: flex;
        justify-content: space-between;
        padding: 10px;
        height: 100px;
        border: solid 1px;
        border-color: #8cc63f;
        border-radius: 10px;
      "
    >
      <div
        style="
          min-width: 100%;
          padding: 15px;
          margin: 0;
          flex-direction: row;
          justify-content: space-between;
          display: flex;
          align-items: center;
        "
      >
        <slot name="image"></slot>
        <slot class="category" name="title"></slot>
      </div>
    </div>
  </md-card>
</template>
<script>
export default {
  name: "client-dashboard-card",
  props: {
    headerColor: {
      type: String,
      default: "",
    },
  },
  methods: {
    getClass: function (headerColor) {
      return "md-card-header-" + headerColor + "";
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/components/Cards/InvestorDashboardCard.vue